import { render } from "./PontajIntroducere.vue?vue&type=template&id=324574b8&scoped=true&ts=true"
import script from "./PontajIntroducere.vue?vue&type=script&lang=ts"
export * from "./PontajIntroducere.vue?vue&type=script&lang=ts"

import "./PontajIntroducere.vue?vue&type=style&index=0&id=324574b8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-324574b8"]])

export default __exports__